import EventDispatcher from "backbone-events-standalone";
import {
  find as _find,
  get as _get,
  reject as _reject,
  slice as _slice,
  clone,
  compact,
  curry,
  flow,
  head,
  indexOf,
  isArray,
  isNumber,
  isString,
  isUndefined,
  last,
  map,
  reduce,
  size,
  uniq,
  uniqBy,
  without,
} from "lodash";

const CHANGE_EVENT = "CHANGE_EVENT";

const same = (fields, updatedEntry, entry) => {
  return reduce(
    fields,
    (acc, field) => {
      return (
        acc && _get(entry, field, null) === _get(updatedEntry, field, null)
      );
    },
    true
  );
};

const mapUpdate = curry((fields, updatedEntry, entry) => {
  return same(fields, updatedEntry, entry) ? updatedEntry : entry;
});

const RadarSet = function (fields) {
  fields = fields || [];
  const sizeFields = size(fields);
  const oneField = sizeFields === 1;
  let collection = [];
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self = this;

  const forceTrigger = () => {
    self.trigger(CHANGE_EVENT);
  };

  const set = (entries) => {
    if (sizeFields) {
      entries = uniqBy(entries || [], (entry) =>
        map(fields, (field) => _get(entry, field, "")).join("_")
      );
    } else {
      entries = uniq(entries);
    }
    collection = entries;
    forceTrigger();
    return collection;
  };

  const get = () => clone(collection);

  const unsafeGet = () => collection;

  const cleanPredicate = (entry) =>
    // @ts-ignore
    isString(entry) || isNumber(entry) ? entry : get(entry, head(fields), "");

  const find = (predicate) => {
    if (!sizeFields) {
      return indexOf(get(), predicate) !== -1 ? predicate : undefined;
    } else if (oneField) {
      return _find(get(), [fields[0], cleanPredicate(predicate)]);
    } else {
      return _find(get(), predicate);
    }
  };

  const findMultiple = (predicates) => compact(map(predicates, find));

  const reject = (predicate) => {
    if (!sizeFields) {
      return set(without(get(), predicate));
    } else if (oneField) {
      return set(_reject(get(), [fields[0], cleanPredicate(predicate)]));
    } else {
      return set(_reject(get(), predicate));
    }
  };

  const slice = (a, b) => _slice(get(), a, b);

  const splice = (a, b) => {
    const temp = get();
    const data = temp.splice(a, b);
    set(temp);
    return data;
  };

  const add = (entries) => {
    // @ts-ignore
    set(get().concat(isArray(entries) ? entries : [entries]));
  };

  const unshift = (entries) => {
    set((isArray(entries) ? entries : [entries]).concat(get()));
  };

  const update = (entry) => {
    if (!sizeFields) {
      throw new Error("Cant update an entry without fields");
    }
    return set(map(get(), mapUpdate(fields, entry)));
  };

  const flush = () => set([]);

  const exist = (predicate) => !isUndefined(find(predicate));

  // @ts-ignore
  this.flush = flush;
  // @ts-ignore
  this.set = set;
  // @ts-ignore
  this.get = get;
  // @ts-ignore
  this.unsafeGet = unsafeGet;
  // @ts-ignore
  this.find = find;
  // @ts-ignore
  this.add = add;
  // @ts-ignore
  this.unshift = unshift;
  // @ts-ignore
  this.findMultiple = findMultiple;
  // @ts-ignore
  this.reject = reject;
  // @ts-ignore
  this.slice = flow(slice, set);
  // @ts-ignore
  this.getSlice = slice;
  // @ts-ignore
  this.splice = splice;
  // @ts-ignore
  this.size = flow(get, size);
  // @ts-ignore
  this.last = flow(get, last);
  // @ts-ignore
  this.first = flow(get, head);
  // @ts-ignore
  this.exist = exist;
  // @ts-ignore
  this.update = update;
  // @ts-ignore
  this.forceTrigger = forceTrigger;
  // @ts-ignore
  this.onChange = (callback) => {
    self.on(CHANGE_EVENT, callback);
  };
  // @ts-ignore
  this.offChange = (callback) => {
    self.off(CHANGE_EVENT, callback);
  };
};

export function create(field) {
  const set = new RadarSet(field);
  EventDispatcher.mixin(set);
  return set;
}
